import { render, staticRenderFns } from "./page-display.vue?vue&type=template&id=45cfba58&scoped=true&"
import script from "./page-display.vue?vue&type=script&lang=js&"
export * from "./page-display.vue?vue&type=script&lang=js&"
import style0 from "./page-display.vue?vue&type=style&index=0&id=45cfba58&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cfba58",
  null
  
)

export default component.exports